export var SearchMakersWithFiltersSortBy;
(function (SearchMakersWithFiltersSortBy) {
    SearchMakersWithFiltersSortBy["NAME"] = "NAME";
    SearchMakersWithFiltersSortBy["SCORE"] = "SCORE";
    SearchMakersWithFiltersSortBy["FIRST_ACTIVE_AT"] = "FIRST_ACTIVE_AT";
    SearchMakersWithFiltersSortBy["MINIMUM"] = "MINIMUM";
    SearchMakersWithFiltersSortBy["STOCKIST"] = "STOCKIST";
    SearchMakersWithFiltersSortBy["TRENDING_AT_PROMOTIONAL_EVENT"] = "TRENDING_AT_PROMOTIONAL_EVENT";
    SearchMakersWithFiltersSortBy["RECENTLY_FOLLOWED"] = "RECENTLY_FOLLOWED";
})(SearchMakersWithFiltersSortBy || (SearchMakersWithFiltersSortBy = {}));
